import { createSelector, ReduxUtils } from '../../dependencies';

export const isFormReadySelector = createSelector(
    [state => ReduxUtils.apiSelector(state, 'tags', 'fetch')],
    ({ inProgress, success }) => {
        return !inProgress && success;
    },
);
